/**
 * @file useFieldErrors.tsx
 *
 * @fileoverview Hook to set field errors in the form based on backend validation errors.
 */

import { useEffect } from 'react';

export const useFieldErrors = (fieldErrorList, setError) => {
  useEffect(() => {
    fieldErrorList?.forEach((error) => {
      // Handle some known edge cases where we are setting ids directly
      // in components and not via the EntityDefinition.
      const edgeCases = {};

      setError(
        edgeCases[error?.property_path] || error?.property_path,
        {
          message: error?.message,
        },
        {
          shouldFocus: true,
        },
      );
    });
  }, [fieldErrorList, setError]);
};
